// src/index.tsx
import { Global } from "@emotion/react";
import {
  fontFaceLabGrotesque400NormalWoff2,
  fontFaceLabGrotesque500NormalWoff2,
  fontFaceLabGrotesque700NormalWoff2
} from "@airhelp/design-tokens";
import { jsx } from "react/jsx-runtime";
var fontStyles = `
@font-face {
  font-family: "Lab Grotesque";
  src: url("${fontFaceLabGrotesque400NormalWoff2}") format("woff2");
  font-weight: 400;
  font-style: normal;
  font-display: fallback;
}

@font-face {
  font-family: "Lab Grotesque";
  src:  url("${fontFaceLabGrotesque500NormalWoff2}") format("woff2");
  font-weight: 500;
  font-style: normal;
  font-display: fallback;
}

@font-face {
  font-family: "Lab Grotesque";
  src:  url("${fontFaceLabGrotesque700NormalWoff2}") format("woff2");
  font-weight: 700;
  font-style: normal;
  font-display: fallback;
}
`;
var Fonts = () => /* @__PURE__ */ jsx(Global, {
  styles: fontStyles
});
export {
  Fonts,
  fontStyles
};
